import { render, staticRenderFns } from "./finished.vue?vue&type=template&id=2ca6bb18&scoped=true"
import script from "./finished.vue?vue&type=script&lang=js"
export * from "./finished.vue?vue&type=script&lang=js"
import style0 from "./finished.vue?vue&type=style&index=0&id=2ca6bb18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6bb18",
  null
  
)

export default component.exports